/** Read evidence from the mounted form, never from the requested command.
 * @param {object} reported listener's proposed modal identity
 * @return {object|undefined} observed evidence, or an unconfirmed report
 */
export function observeModal(reported) {
	if (!reported || typeof reported !== 'object') return undefined;
	const root = [...document.querySelectorAll('[data-agent-modal-id]')].find(
		(node) => node.getAttribute('data-agent-modal-id') === reported.modal_id &&
			!node.closest('[hidden], [aria-hidden="true"]') &&
			window.getComputedStyle(node).display !== 'none' &&
			window.getComputedStyle(node).visibility !== 'hidden' &&
			node.getClientRects().length > 0,
	);
	if (!root) return {...reported, observed: false};
	const evidence = {modal_id: root.getAttribute('data-agent-modal-id'), observed: true};
	for (const key of ['entity_id', 'variant', 'section_id']) {
		const value = root.getAttribute(`data-agent-${key.replace(/_/g, '-')}`);
		if (value) evidence[key] = value;
	}
	return evidence;
}
